// @ts-nocheck
/* global fflate */
/** LiveArt add to cart script v2.0, support LACP v3.2.0-rc.1+ */
(function () {
  "use strict";

  // --- config ---
  // attempts start from 0
  const RETRY = { attempts: 5, baseDelayMs: 1000, maxDelayMs: 8000 };
  const REDIRECT_DELAY_MS = 3000;

  // --- helpers ---
  function getQueryParam(key) {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(key);
    return value === null ? null : value;
  }

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  function backoffDelay(attempt, retryAfterSec) {
    if (retryAfterSec) {
      return Math.min(retryAfterSec * 1000, RETRY.maxDelayMs);
    }
    const exp = RETRY.baseDelayMs * 2 ** attempt;
    const jitter = Math.random() * 0.3 * exp;
    return Math.min(exp + jitter, RETRY.maxDelayMs);
  }

  // --- parsing ---
  function parseCartItems(key) {
    const cartItems = getQueryParam(key);
    if (!cartItems) return null;

    const compressMethod = getQueryParam("cmethod");
    switch (compressMethod) {
      case "fflate":
        return parseFflate(cartItems);
      case "base64":
      case null:
      default:
        return parseBase64(cartItems);
    }
  }

  function parseBase64(cartItems) {
    try {
      return JSON.parse(atob(cartItems));
    } catch (e) {
      console.error("liveart: legacy base64 decode failed", e);
      return null;
    }
  }

  /**
   * Supported in Chrome 38+, Edge 79+, Safari 10.1+, Opera 25+.
   * @param {string} cartItems base64url encoded string of compressed json by fflate (default deflate)
   */
  function parseFflate(cartItems) {
    try {
      // convert url-safe base64 (base64url, RFC4648 §5) to default base64 (RFC4648 §4)
      const regularBase64 = cartItems.replace(/_/g, "/").replace(/-/g, "+");
      const compressedData = new Uint8Array(
        atob(regularBase64)
          .split("")
          .map((c) => c.charCodeAt(0)),
      );
      const decompressedData = fflate.inflateSync(compressedData);
      const decompressedString = new TextDecoder().decode(decompressedData);
      return JSON.parse(decompressedString);
    } catch (e) {
      console.error("liveart: fflate decode failed", e);
      return null;
    }
  }

  // --- validation ---
  function isValidCartItems(value) {
    if (!Array.isArray(value)) {
      console.error("liveart: items is not an array");
      return false;
    }

    if (value.length <= 0) {
      console.error("liveart: items is empty");
      return false;
    }
    return true;
  }

  // --- posting ---
  async function postAddToCartWithRetry(items) {
    for (let attempt = 0; attempt < RETRY.attempts; attempt++) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items }),
        });

        // Parse response according to content-type
        const data = await response.json();

        // Handle HTTP errors (non-2xx)
        if (!response.ok) {
          const message = `HTTP error: ${response.status}`;
          const error = new Error(data?.error?.message);

          error.status = response.status;
          error.headers = response.headers;
          error.data = data;
          throw error;
        }

        if (!data?.items.length) {
          throw new Error("Received empty items response");
        }

        return { items: data.items, attempt };
      } catch (err) {
        console.error("liveart: Failed to add to cart", err.data || err.message);
        if (attempt < RETRY.attempts) {
          console.log(`liveart: attempt ${attempt}, retrying`);
          const retryAfter = Number(err?.headers?.["Retry-After"]) || 0;
          await sleep(backoffDelay(attempt, retryAfter));
        } else {
          console.log("liveart: Max number of attempts reached");
        }
      }
    }
    return { items: null, attempt: RETRY.attempts - 1 };
  }

  function redirectToCart(parameters = {}) {
    const origin = window.parent.location.origin;
    const query = new URLSearchParams(parameters);
    window.location.replace(origin + "/cart?" + query.toString());
  }

  async function main() {
    const cartItems = parseCartItems("cart_items");
    let attempt = 0;
    if (isValidCartItems(cartItems)) {
      await sleep(REDIRECT_DELAY_MS);
      const data = await postAddToCartWithRetry(cartItems);
      attempt = data.attempt;
    }
    redirectToCart({ debugAttempt: attempt });
  }

  // fflate is loaded before this script via `defer` + document order
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();
